import React from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import { Spacer } from 'app/member/layouts/generic';
import { GridColumn, GridRow } from 'app/member/layouts/grid';
import SlidingNav from 'app/shared/nav/sliding/sliding';
import { WebPushMessageLogs } from './logs/sent';
import { WebPushMessageStatBar } from './statbar';
import { WebPushBasicInfo } from './details/basic';

const getNavItems = (message_id) => [
  {
    title: 'Recipients',
    path: `/messaging/mobile/${message_id}`
  }
];

export const MobilePushMessageViewPage = () => {
  const { id } = useParams();

  return (
    <>
      <GridRow>
        <GridColumn>
          <WebPushBasicInfo id={id} />
        </GridColumn>
        <GridColumn span={3}>
          <GridRow num_of_columns={1}>
            <WebPushMessageStatBar id={id} />
          </GridRow>
          <Spacer multiple={4} />
          <GridRow num_of_columns={1}>
            <SlidingNav nav_items={getNavItems(id)} />
            <Routes>
              <Route path="/*" element={<WebPushMessageLogs id={id} />} />
            </Routes>
          </GridRow>
        </GridColumn>
      </GridRow>
    </>
  );
};
